import { render, staticRenderFns } from "./LgInput.vue?vue&type=template&id=8ecc06e8&scoped=true&"
import script from "./LgInput.vue?vue&type=script&lang=js&"
export * from "./LgInput.vue?vue&type=script&lang=js&"
import style0 from "./LgInput.vue?vue&type=style&index=0&id=8ecc06e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecc06e8",
  null
  
)

export default component.exports